module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("a long way from a blizzard")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindentx"
  }, [_vm._v("Gaia had no problem understanding his broken-nose English.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('code', [_c('strong', [_vm._v("THE DEALER SMILED AS GAIA CAME")])]), _vm._v(" close. “Hey,” he said. He took the toothpick from between his yellow teeth and waved it through the snowy air. “You’re out awful late, little girl.”")])]), _c('p', {
    staticClass: "sidebarr"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('strong', [_vm._v("A Regular Franken-Nazi")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia Moore shoved her hands down inside her pockets and walked closer. “I’m not a little girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, babe, whatever.” The dealer replaced his toothpick, stomped his feet, and rubbed his hands together. “So what is it you want? I’m freezing out here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How sad.” Gaia took a long look at the dealer. He was a big man, maybe six-foot three, with big hands, thick arms, an equally thick neck, and hair that had been shaved down to a gray stubble. A regular Franken-Nazi. Exactly the kind of guy Gaia loved to pick a fight with—especially after what had happened over the last couple of weeks. "), _c('code', [_c('strong', [_vm._v("It was easy to see why big boy felt confident enough to be working alone at midnight")])]), _vm._v(". Most of the dealers Gaia ran into were wimps, but this guy looked strong enough to pick up a park bench and beat somebody with it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The dealer scowled. “Hey, girl. You shopping or staring?” His big hands dipped into his pockets and ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("came out with a display of his stock. Clumps of white crystal shoved in tiny bottles. Brown powder in glassine envelopes. “You want something?”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” Gaia nodded as she looked at the drugs. “Yeah, I want something.” She slowly took her hands from her pockets. “I want you to get out of my park.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man took a moment to react. “Your park?” He shoved his wares into his coat. “What makes you think this is your park, chicky?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia jerked her thumb back along the path she had been following. “I live over there,” she said. She pointed ahead. “And my favorite doughnuts are over there. I figure that makes everything in between mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer was big, but his sense of humor was not. A single heavy black eyebrow crunched down over his squinted eyes. “If you’re not making a buy, kid, get out of my face.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Gaia’s turn to smile. “Make me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The toothpick fell from the big man’s lips. “You got some kind of brain damage? Hell, girl, I clean bigger things than you off my boots.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia glanced down at the man’s stained coat, then back at his face. “From the look of you, I wouldn’t think you ever cleaned anything.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The dealer opened his mouth as if he was going to reply, then he stopped and shook his head. “You want to be nuts, you be nuts on your own time. I got business ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("to do.” He turned his big shoulders and started across the park toward the empty, snow-covered chess tables.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You afraid of a girl?” Gaia called after him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer kept walking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia cupped her hands beside her mouth. “Police!” she shouted. “You better come arrest this asshole!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer froze. He spun around to face Gaia. “Shut up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Police!” Gaia shouted again. “You better hurry! He’s wearing a black coat, and he’s got a pocket full of crack!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut the hell up!” The dealer stomped back along the snowy path. “You want to be hurt? If that’s what you want, I’ll—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Police!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('code', [_vm._v("For a big man, the dealer moved fast")]), _vm._v(". He charged and swung a knotted fist at Gaia with enough force to drop a horse. Only Gaia wasn’t standing there anymore. She stepped left, ducked under the man’s arm, caught his thick wrist, and gave a hard tug.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia’s move pulled the dealer off balance. He staggered forward past the place where Gaia was crouching. Before he could turn, Gaia planted her hands against the man’s broad back and gave a shove. The dealer tripped and fell facedown on the frozen ground.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The big man scrambled back to his feet. There was snow on his stubble-covered head and more caught in his "), _c('code', [_c('strong', [_vm._v("shaggy unibrow")])]), _vm._v(". “I hope you like this snow,” he said. “Because I’m gonna make you lick it all up.”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He lunged at Gaia, but she dodged again. This time she rose up on the ball of one foot, carefully aimed a kick at the man’s ribs—and slipped in the snow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ten thousand lessons had taught Gaia how to fall. They didn’t help this time. Her feet went up, and Gaia went down. She landed on her butt with enough force to knock most of the air from her lungs and send a jolt of pain running up her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The big man was on her in a moment. One big hand closed around Gaia’s right arm and jerked her from the ground. The other hand drove into her gut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The muscles in Gaia’s stomach spasmed. What little air remained in her body hissed out between her teeth. Gaia gasped and strained to pull in a breath. The man tossed her back to the ground and gave her a kick that pounded into her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grunted in satisfaction. “I don’t think you’re going to make any more trouble for me, babe.” He drew back his leg and aimed a second kick at Gaia’s head.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Gaia rolled, put her hands under her chest, and flipped onto her feet. Before the man had recovered from his missed kick, Gaia spun and planted a punch ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("in the center of his stomach. She punched again, backed away, and followed up with a high kick that spun the man’s head around.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though it was the guy who was getting hit, Gaia was the one feeling dizzy. She still couldn’t breathe. She was fighting on nothing but the oxygen in her lungs, and that was running out fast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the drug dealer had been smaller, that kick would have been enough to send him flying. The fight would have been over in five seconds flat. Instead the big man only staggered for a moment, then lunged toward Gaia again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia dropped onto her hands and swept the big man’s legs out from under him. As he was falling, she landed a fresh kick "), _c('code', [_c('strong', [_vm._v("square in the middle of his face")])]), _vm._v(". Blood sprayed from his shattered nose. It arced away from the blow and laced across the snow in a dark red line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a moment Gaia froze. She looked at the snow with its stain of blood, and her mind went spinning back. A gunshot echoed through her memory. She saw her mother lying on the kitchen floor....")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The oxygen gauge in Gaia’s body reached "), _c('em', [_vm._v("E.")]), _vm._v(" She dropped out of her memories and onto her knees. Air. She needed air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer groaned and started to get up. He fumbled at Gaia with sausage-sized fingers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Gaia’s stomach muscles relaxed, and she managed ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("to grab a lungful of air. She threw off the guy’s hand, rolled away across the snow, and got up. She squeezed down another breath. The oxygen flowed into her muscles like cool water.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer stood and faced her across the snow. “Ooh liddle bidch,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia had no problem understanding his "), _c('code', [_c('strong', [_vm._v("broken-nose English")])]), _vm._v(". She pulled in enough air to answer him. “Let’s get this over with. I want to get my doughnuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The big man came for her. He was more cautious this time. Gaia could see the way his eyes danced back and forth as he tried to anticipate her move. It didn’t help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia waited until he grabbed for her, slipped away, and drove a kick into his side. Before he could turn, she drove another kick into his back. It was a kidney shot, illegal in any karate tournament. This wasn’t a tournament.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer made a deep grunt and fell to his knees. Gaia kicked him again. And again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Top,” said the dealer. “Pweez top.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia took a step back. “You going to get out of my park?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer nodded, sending fresh blood dripping from his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you’ll never come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Neba. I swear. Neba.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Gaia nodded. “All right, then, go.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The dealer got slowly to his feet and stumbled away. Gaia stood and watched him until the big man was "), _c('code', [_c('strong', [_vm._v("only a smudge in the snowy distance")])]), _vm._v(". Then she fell onto the nearest park bench.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the space of sixty seconds Gaia was completely paralyzed. It was the cost of being stronger and faster during the fight—the price she paid for running her muscles at two hundred percent. She lay there on the bench, unable to move a muscle. She was glad that the park was deserted. The only thing worse than being helpless was having someone else see her when she was helpless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned her head and saw the dealer’s blood on the ground. Once again, images flooded her mind. Night. Snow. "), _c('code', [_c('strong', [_vm._v("Blood")])]), _vm._v(". Her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gaia shook the images from her head. She propped herself up on her hands, took in a deep, cold breath, and tried to forget.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("GAIA")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "lgnoindent"
  }, [_c('code', [_c('strong', [_vm._v("My")]), _vm._v(" mom loved snow, but she didn’t like snowball fights. Or at least, she’d make you believe she didn’t like snowball fights. Oh, no, she only came outside to enjoy the beauty of a winter’s day. Snow on the tree branches. The way everything sparkled in the sun. All that shit")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("She was a good actress, my mom. And if you believed her long enough to look away—pow! You’d catch a cold one right on the ear")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("The best thing I remember about those snows was that the snow stayed white for a month at a time. Cloud white. White like things are in dreams. All clean and perfect")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("I know that things can seem a lot better when you’re remembering than they really were. But those snows really were great. Really")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("City snow is not pretty snow. That’s the truth. And that’s the closest thing to a poem you’re going to get out of me")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('code')]), _c('code', [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Back when I was a kid. Before my mom . . . I mean, before my dad . . . Let’s just say before. Before I came to New York City. Back then I used to see real snow")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("I know, this is already starting to sound like one of those stupid stories your fat uncle Pete tells about the good old days. You know, the “when I was a little kid it snowed all year long and I had to walk ten miles to school and we couldn’t afford shoes so I had to wear bread wrappers on my feet and it was all uphill both ways” story")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('code', [_vm._v("Old people say things like this because they’re way into this nostalgia thing. They want to look back at the past and make it so everybody was braver and nicer and better than they are now. They had it tough, but they stuck together. They didn’t get anything but an orange for Christmas, and they were happy. ")])]), _c('code', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("They ate dirt six days a week, and they liked it")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("My story’s not like that. For one thing, I’m only seventeen, so I didn’t grow up with dinosaurs or go hunting mastodons. The other difference is, no nostalgia")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Let me tell you right now: Nostalgia sucks")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("All those old stories are nothing but dressed-up lies. Who wants to look back, anyway? I mean, do you want to look back and see how your mom died? Do you really want to think about how your father disappeared and never bothered to so much as write? Do you want to remember how you got shuffled off from one place to another and end up being forced to live with two people you barely know? No. Believe me, thinking about the past is just plain stupid")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("That’s why I’m just talking about snow")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('code', [_vm._v("It snowed in the mountains. ")])]), _c('code', [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Back then, I had a mom and a dad just like a regular girl. That part of the story seems like a fairy tale now, even to me, but it really did happen. I had a mother. I even have the pictures to prove it")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Of course, if you look at the pictures, you probably wouldn’t think they were very good evidence. On one side you have my mom: always stylish, completely charming, totally beautiful. And then there’s me. I’m . . . not my mother")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Even back in those days of yore, the Moore family wasn’t exactly typical. First off, my dad was like a major government spy. Half the time he was off to some jungle or desert or foreign capital. I never knew which one because he could never talk about it. Then when he was home, Dad dedicated himself to my little problem. The Gaia-don’t-get-scared-of-anything problem")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('code', [_vm._v("Which wouldn’t have been such ")])]), _c('code', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("a problem at all except my dad was afraid that I wouldn’t get scared when I should. Which was completely wrong. Just because I’m fearless doesn’t mean I’m stupid. I don’t go jumping off cliffs. I don’t get into a fight with more than two or three idiots at a time. Usually")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("But Dad made me study every martial art in creation so I could stomp the crap out of the people I should have been afraid of but wasn’t. By the time he was through, he had turned me into the muscle-bound freak girl I am today")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Snow. This is about snow")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('code', [_vm._v("In the mountains it snowed for weeks at a time. Not wimpy little flurries. Serious snow. And when it stopped, we would build snowmen and snow forts and snow anything else you could think of. My dad would even stop telling me about “the sixteen deadly pressure points on the human body” long enough to come outside and ")])]), _c('code', [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("take part in snowball Armageddon")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Of course, not every snow was perfect. I mean, it was snowing on that night, too. The last night")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Blood melts into the snow. You might think it would spread out and fade. Maybe it would even turn some shade of pink. It doesn’t. Blood is dark against the snow. That night, that last night, it looked almost black")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("Okay, now let’s talk about city snow. Let’s talk about snow in New York")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("First off, it doesn’t snow that much here. People talk about this place like it’s the north slope of Alaska, but we’re lucky to have two decent snows a year. Every little flurry here is treated like an emergency. Two flakes get together, half the city runs for home")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('code', [_vm._v("When the snow does fall, it starts out white, just like mountain snow. But give it two hours on the ground, and it turns into ")])]), _c('code', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("certified City Snow"), _c('sup', [_vm._v("™")]), _vm._v(", pat. pending")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("City Snow is not a product of nature. It looks like a mixture of wet cement and motor oil. Ever see a Coke Slurpee? That’s pretty close. Not the kind of stuff you want someone to wad up and throw at you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lgindent"
  }, [_c('code', [_vm._v("I guess you could make a snow fort in the park—if you worked fast enough to get it done before the snow turned to goo. You might get in a few decent snowballs. Maybe make a snowman, too")]), _vm._v(".")])]), _c('p', {
    staticClass: "lgindent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('code', [_vm._v("But some jerk would probably come along and mug it.")])]), _c('code', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 78
// module chunks = 0